import {request} from '@/utils/request'

// 验证二维码
export function validateCode(query) {
  return request({
    url: '/tripartite/verifyBookValidateCode',
    method: 'get',
    params: query
  })
}
export function equitiesTypeList(query) {
  return request({
    url: '/equities/type/list',
    method: 'get',
    params: query
  })
}
//获取配置内容
export function configLatest(query) {
  return request({
    url: '/content/config/latest',
    method: 'get',
    params: query
  })
}
export function getMiniScheme(data) {
  return request({
    url: '/wechat/generate/scheme',
    method: 'post',
    data
  })
}
